export default __webpack_public_path__ + "static/media/mm.908a7bd0.png";